
import LayoutContent from '../../components/layouts/content2';
import React, {useState, useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import { getData } from '../../helpers/indexedDbHelper';
import SpecialsScreen from './specials';
import { useRefresh } from '../../hooks/useRefresh';
import ListProducts from './ListProducts';


function Index({setShowHappy}) { 
     const {change} = useRefresh();
    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;

     const [showSpecials, setShowSpecials] = useState(false);
     const [menus, setMenus] = useState([]);
    const [dishs, setdishs] = useState(false);
     const [showListProduct, setShowListProduct] = useState(false);
    
    const [tequila, settequila] = useState(false);
  const [toptequila, settoptequila] = useState(false);
  const [aguardiente, setaguardiente] = useState(false);

  const [wine, setwine] = useState(false);

  const [whiskey, setwhiskey] = useState(false);

  const [mezcal, setmezcal] = useState(false);
  const [vodka, setvodka] = useState(false);
    const [cognac, setcognac] = useState(false);
    
     useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
               
                setMenus(data);
            });
        }, [change]);
    
    
          useEffect(() => {
                menus.map((item) => {
                     if (item.id === 497) {
                        settequila(item);
                    }
                    if (item.id === 531) {
                        settoptequila(item);
                    }
                    if (item.id === 498) {
                        setaguardiente(item);
                    }

                    if (item.id === 499) {
                        setwine(item);
                    }

                    if (item.id === 502) {
                        setwhiskey(item);
                    }

                    if (item.id === 533) {
                        setmezcal(item);
                    }
                    if (item.id === 529) {
                        setvodka(item);
                    }
                    if (item.id === 532) {
                        setcognac(item);
                    }
                });
          }, [menus]);
    
    
    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent showBack={true} setShowSpecials={setShowSpecials} setShowListProduct={setShowHappy}>
                <div  style={{padding: '0 20px'}}>
                     
                    <div
                        style={{
                        justifyContent: 'center',
                            alignItems: 'center',
                        marginTop: 100
                        }}>
                        <p
                        style={{
                            fontFamily: 'Roadstore',
                            color: '#B20B0A',
                            fontSize: 90,
                        }}>
                        bottles
                        </p>
                    </div>
                    

                    <div>
                        <div
                            style={{display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 20,
                            }}>
                            <div
                                onClick={() => {
                                    setdishs(tequila)
                                    setShowListProduct(true)
                                }
                                }
                                style={{
                                    width: 400,
                                    height: 80,
                                    display: 'flex',
                                    alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 11,
                                    marginTop: 20,
                                background: '#B20B0A'
                                }}>
                               <p style={{fontFamily: 'RoadStore', color: 'white', fontSize: 30}}>house tequila</p>
                            </div>
                             <div
                                onClick={() => {
                                    setdishs(toptequila)
                                    setShowListProduct(true)
                                }
                                }
                                style={{
                                    width: 400,
                                    height: 80,
                                    display: 'flex',
                                    alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 11,
                                    marginTop: 20,
                                background: '#B20B0A'
                                }}>
                                <p style={{ fontFamily: 'RoadStore', color: 'white', fontSize: 30 }}>
                                    top shelf tequila
                               </p>
                            </div>
                        </div>
                        <div
                            style={{display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 20,
                            }}>
                            <div
                                onClick={() => {
                                    setdishs(whiskey)
                                    setShowListProduct(true)
                                }
                                }
                                style={{
                                    width: 400,
                                    height: 80,
                                    display: 'flex',
                                    alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 11,
                                    marginTop: 20,
                                background: '#B20B0A'
                                }}>
                                <p style={{ fontFamily: 'RoadStore', color: 'white', fontSize: 30 }}>
                                    scotch and whiskey
                               </p>
                            </div>
                             <div
                                onClick={() => {
                                    setdishs(aguardiente)
                                    setShowListProduct(true)
                                }
                                }
                                style={{
                                    width: 400,
                                    height: 80,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                flexDirection: 'column',
                                borderRadius: 11,
                                    marginTop: 20,
                                background: '#B20B0A'
                                }}>
                                <p style={{ fontFamily: 'RoadStore', color: 'white', fontSize: 30 }}>
                                   aguardiente y ron

                                </p>
                                <p style={{ fontFamily: 'RoadStore', color: 'white', fontSize: 14 }}>
                                    (from colombia)
                                </p>
                            </div>
                        </div>
                        <div
                            style={{display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 20,
                            }}>
                            <div
                                onClick={() => {
                                    setdishs(mezcal)
                                    setShowListProduct(true)
                                }
                                }
                                style={{
                                    width: 400,
                                    height: 80,
                                    display: 'flex',
                                    alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 11,
                                    marginTop: 20,
                                background: '#B20B0A'
                                }}>
                                <p style={{ fontFamily: 'RoadStore', color: 'white', fontSize: 30 }}>
                                   Mezcal
                               </p>
                            </div>
                             <div
                                onClick={() => {
                                    setdishs(vodka)
                                    setShowListProduct(true)
                                }
                                }
                                style={{
                                    width: 400,
                                    height: 80,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                flexDirection: 'column',
                                borderRadius: 11,
                                    marginTop: 20,
                                background: '#B20B0A'
                                }}>
                                <p style={{ fontFamily: 'RoadStore', color: 'white', fontSize: 30 }}>
                                  Vodka

                                </p>
                               
                            </div>
                        </div>
                        <div
                            style={{display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                                gap: 20,
                            }}>
                            <div
                                onClick={() => {
                                    setdishs(cognac)
                                    setShowListProduct(true)
                                }
                                }
                                style={{
                                    width: 400,
                                    height: 80,
                                    display: 'flex',
                                    alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: 11,
                                    marginTop: 20,
                                background: '#B20B0A'
                                }}>
                                <p style={{ fontFamily: 'RoadStore', color: 'white', fontSize: 30 }}>
                                   cognac
                               </p>
                            </div>
                             <div
                                onClick={() => {
                                    setdishs(wine)
                                    setShowListProduct(true)
                                }
                                }
                                style={{
                                    width: 400,
                                    height: 80,
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                flexDirection: 'column',
                                borderRadius: 11,
                                    marginTop: 20,
                                background: '#B20B0A'
                                }}>
                                <p style={{ fontFamily: 'RoadStore', color: 'white', fontSize: 30 }}>
                                  Wines

                                </p>
                               
                            </div>
                        </div>
                         
                    </div>
                   
                </div>
                
                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={setShowHappy} />}
                
                {showListProduct && <ListProducts
                        dishs={dishs}
                        setShowListProduct={setShowListProduct}
                    />}
            </LayoutContent>
        </div>
    );
}
export default Index;